import React from "react";
import people from "../../assets/people.png";
import ai from "../../assets/ai.png";
import "./header.css";

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">
        Let's Build Something amazing with GPT-3 OpenAI
      </h1>
      <p>
      The possibilities with GPT-3 are endless - from creating chatbots that can converse naturally with humans, to generating complex code and even writing entire articles. Let's unleash its potential and build something amazing!
      </p>

      <div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <button type="button">Get Started</button>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} alt="people"/>
        <p>1,600 people requested access a visit in last 24 hours</p>
      </div>
    </div>

    <div className="gpt3__header-image">
      <img src={ai} alt="ai"/>
    </div>
  </div>
);

export default Header;
